import axios from "axios";
import { ApiUrl } from "../../api/apiUrls";

export const getFooterMenuDetailApi = (pageId) => {
  return axios.get(ApiUrl.LandingPage.GetFooterFeaturesDetail(pageId)).then(({ data }) => data);
};